/**
 *
 * Header Sticky.
 *
 * This one include the logic for the Header Menu and the Masthead Ad
 * Stick elements at different positions based on window size and scroll direction
 *
 */
import { Debounce } from '../global/debounce.js';

( function () {
	'use strict';

	const siteHeader = document.querySelector( '.site-header' );

	if ( !siteHeader ) {
		return null;
	}

	const advertHeader = document.querySelector( '.arsenal-masthead-ad__container' );
	advertHeader && advertHeader.setAttribute( 'aria-hidden', 'false' );
	advertHeader && document.body.classList.add( 'masthead-ad-is-active' );

	let headerTopReferenceElement = 'mainContent';
	const headerTopReferenceValue = 195;

	if ( document.body.classList.contains( 'article-2023', 'single-post' ) ) {
		headerTopReferenceElement = 'article';
	}

	const setStickyHeader = () => {
		initialHeaderClasses();
	};

	const setStickyHeaderArea = Debounce( function () {
		initialHeaderClasses();

		// Media query to check if the screen width is 767px or less
		const mediaQuery = window.matchMedia( '(max-width: 767px)' );

		if ( advertHeader && !advertHeader.classList.contains( 'sticky-move-done' ) ) {
			if ( !advertHeader.classList.contains( 'sticky-move' ) ) {
				advertHeader.classList.add( 'sticky-move' );
			}
		}

		if ( mediaQuery.matches ) { // If screen width is <= 767px
			setTimeout( function () {
				if ( siteHeader.classList.contains( 'stuck' ) ) {
					siteHeader.classList.add( 'stuck-done' );
				}
				if ( advertHeader.classList.contains( 'sticky-move' ) ) {
					advertHeader.classList.remove( 'sticky-move' );
					advertHeader.classList.add( 'sticky-move-done' );
				}
			}, 8000 );
		}
	}, 20, false );

	const initialHeaderClasses = () => {
		const headerTopReference = document.getElementById( headerTopReferenceElement ).getBoundingClientRect().top;

		if ( !siteHeader.classList.contains( 'stuck-done' ) ) {
			if ( headerTopReferenceValue >= headerTopReference ) {
				siteHeader.classList.add( 'stuck' );
			} else {
				siteHeader.classList.remove( 'stuck' );
			}
		}
	};

	/* Onload */
	setStickyHeader();
	/* On scroll */
	window.addEventListener( 'scroll', setStickyHeaderArea );
	/* On resize */
	window.addEventListener( 'resize', setStickyHeaderArea );
} )();
